<template>
    <div class="g tool-tip-inner">
        <mdCaption
            v-if="content.caption"
            :caption="content.caption"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g tool-tip-content">
            <div class="g tool-tip-content-inner">
                <div :style="style" v-html="content.html"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'

    export default {
        components: {
            mdCaption,
        },
        props: {
            content: {
                type: Object,
                require: true
            }
        },
        computed: {
            style: function(){
                let $style = {};

                let _width = this.content.width,
                    _height = this.content.height;

                if( _width && typeof _width === 'number' ) {
                    $style.width = _width +'px';
                }else if( _width && typeof _width === 'string') {
                    $style.width = _width;
                }else {
                    $style.width = 'auto';
                }

                if( _height && typeof _height === 'number' ) {
                    $style.height = _height +'px';
                }else if( _height && typeof _height === 'string') {
                    $style.height = _height;
                }else {
                    $style.height = 'auto';
                }

                return $style;
            }
        }
    }
</script>

<style scoped lang="scss">

    .g.tool-tip-inner {
        
    }
</style>
